function encode(value) {
  return encodeURIComponent(value)
    .replace(/%40/gi, '@')
    .replace(/%3A/gi, ':')
    .replace(/%24/gi, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/gi, '+');
}

export default function buildUrl(url, params) {
  if (!params) {
    return url;
  }

  const parts = _(params)
    .map(function (value, key) {
      if (_.isNil(value)) {
        return '';
      }

      if (_.isDate(value) && !isNaN(value.valueOf())) {
        value = value.toISOString();
      } else if (_.isObject(value)) {
        value = JSON.stringify(value);
      }

      return `${encode(key)}=${encode(value)}`;
    })
    .compact()
    .value();

  if (parts.length !== 0) {
    url += (_.includes(url, '?') ? '&' : '?') + parts.join('&');
  }

  return url;
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/utils/build-url.js